import { Component, OnInit } from '@angular/core';
declare var $: any;
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from 'src/app/services/service.service';
import { User } from '../components/app-modules/dashboard/models/user.model';

@Component({
  selector: 'app-user-mngnt',
  templateUrl: './user-security.component.html',
  styleUrls: ['./user-security.component.scss']
})
export class UserSecurityComponent implements OnInit {

  users: any;
  dataObj = new User();
  selectedUser: any;
  prevPass: string = '';
  isEdituser: boolean = false;
  selectedIndex = -1;
  securitySpecs = [];
  modules = [];
  unselectedModules = [];
  selectedModules = [];
  moduleFilterConfig = {
    displayKey: 'moduleName', //if objects array passed which key to be displayed defaults to description
    search: true, //true/false for the search functionlity defaults to false,
    height: '309px', //height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
    placeholder: 'Filter Module', // text to be displayed when no item is selected defaults to Select,
    customComparator: () => { }, // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case,
    limitTo: 100, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    moreText: 'more', // text to be displayed whenmore than one items are selected like Option 1 + 5 more
    noResultsFound: 'No results found!', // text to be displayed when no items are found while searching
    searchPlaceholder: 'Search Module', // label thats displayed in search input,
    searchOnKey: 'moduleName', // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ServiceService,
  ) { }

  ngOnInit() {

    this.getUsers();
    this.service.fetchAllModules().subscribe(modules => {
      this.modules = modules;
    })
  }


  /**
   * Getting user list.
   */
  private getUsers() {
    $(".overlay-loading").show();
    let url = 'get-all-users' + '?size=200&page=0&sort-by=billOfLadingId&order-by=asc';
    this.service.getUserList(url).subscribe(data => {
      $(".overlay-loading").hide();
      this.users = data;
    });
  }


  /**
   * Api call to save user.
   * 
   */
  public saveUserDetails(): void {
    $(".overlay-loading").show();
    this.service.saveUserDetails(this.dataObj, this.prevPass).subscribe(res => {
      this.users = res;
      $(".overlay-loading").hide();
    });
  }

  /**
   *  Used to set selected user details.
   * 
   * @param user 
   */
  public selectRecord(user: User): void {
    this.selectedUser = user;
  }

  public setUserObj(): void {
    this.dataObj = new User();
    this.isEdituser = false;
  }

  /**
   * Delete user.
   */
  public deleteUser(): void {
    this.service.deleteUserDetails(this.selectedUser.userId).subscribe(res => {
    });
  }

  /**
   * Edit user
   */
  public editUser(user: User): void {
    this.dataObj = user;
    this.prevPass = user.password;
    this.isEdituser = true;
  }


  byId(item1: any, item2: any) {
    return item1 && item2 && item1.tenantId === item2.tenantId;
  }

  byRoleId(item1: any, item2: any) {
    return item1 && item2 && item1.roleId === item2.roleId;
  }

  async fetchSecuritySpecs(userId) {

    this.selectedUser = userId;
    $(".overlay-loading").show();
    this.service.fetchUserAccess(userId).subscribe(specs => {
      $(".overlay-loading").hide();
      this.securitySpecs = specs;
      this.unselectedModules = [];

      this.modules.forEach(module => {
        let moduleMatchFound = false;
        this.securitySpecs.forEach(securitySpec => {
          if (securitySpec.userModule.moduleName == module.moduleName) {
            moduleMatchFound = true;
          }
        });
        if (!moduleMatchFound) {
          this.unselectedModules.push(module);
        }
      })



    });
    // $(".overlay-loading").hide();
  }

  deleteUserModule(userModule) {
    this.service.deleteUserModuleMapping(userModule).subscribe(securitySpecs => {
      this.securitySpecs = securitySpecs;
      this.fetchSecuritySpecs(this.selectedUser);
    })
  }

  addUserModule() {
    let selectedUserModules = [];
    this.selectedModules.forEach(module => {
      let matchFound = false;
      this.securitySpecs.forEach(securitySpec => {
        if (securitySpec.userModule.moduleName == module.moduleName) {
          matchFound = true;
        }
      });

      if (!matchFound) {
        let userModule = {
          user: this.selectedUser,
          userModule: module,
          userModuleName: module.moduleName,
          userName: this.selectedUser.email
        };
        selectedUserModules.push(userModule);
      }

    })


    this.service.addUserModuleMapping(selectedUserModules).subscribe(securitySpecs => {
      this.securitySpecs = securitySpecs;
      this.fetchSecuritySpecs(this.selectedUser);
    })
  }
}


